<template>
    <div>
        <!-- Abonelik yönetim modali -->
        <Modal2 v-if="visible" @cancel="onCancel" :showFooter="false" :showTitle="false"
            className="subscription-management-modal">
            <div class="subscription-management-container">
                <!-- Başlık ve Ücretsiz plana geç butonu -->
                <div class="plans-header">
                    <h3 class="plans-title">{{ $t("message.paidSubscriptions") }}</h3>
                </div>

                <!-- Mevcut ücretli planlar listesi -->
                <div class="plans-list-new">
                    <div class="plan-card" v-for="item in plansList" :key="item.currentPlan._id">
                        <div class="left">
                            <div class="icon-wrapper">
                                <DynamicSvg :name="getIconName(item.plan.type)" />
                            </div>
                            <div class="labels">
                                <div class="title">{{ getTitle(item.plan.type) }}</div>
                                <div class="chips">
                                    <span class="chip">{{ periods[item.currentPlan.period] }}</span>
                                    <span class="chip" v-if="getQuantity(item).total > 0">
                                        {{ getQuantity(item).total }}
                                        {{ getQuantityText(item.plan.type) }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <SupsisButton danger size="small" @click="tryCancel(item)">
                                {{ $t("message.cancelSubscription") }}
                            </SupsisButton>
                        </div>
                    </div>
                </div>
            </div>
        </Modal2>

        <!-- Kaynak yönetim modalı -->
        <CancelPlanResourcesModal v-if="showCancelResourcesModal" :visible="showCancelResourcesModal"
            :plan="cancelItem ? cancelItem.plan : {}" @close="showCancelResourcesModal = false" />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DynamicSvg from '../DynamicSvg.vue';
import Modal2 from '../common/Modal2.vue';
import SupsisButton from '../../views/Pages/Settings/components/SupsisButton.vue';
import SupsisTable from '../SupsisTable.vue';
import _ from 'lodash';
import CancelPlanResourcesModal from './CancelPlanResourcesModal.vue';

export default {
    name: 'SubscriptionManagementModal',
    components: {
        Modal2,
        SupsisButton,
        DynamicSvg,
        SupsisTable,
        CancelPlanResourcesModal,
    },
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            plans: state => state.site.plans,
            currentPlans: state => state.site.currentPlans,
            features: state => state.site.features,
            activeUserCount: state => state.user.activeUserCount,
            channels: state => state.channel.channels,
            site: state => state.site.site,
        }),
        ...mapGetters({
            paidSubscriptions: 'site/paidSubscriptions',
            telegramBotFatherEnabled: 'setting/telegramEnabled',
        }),
        plansList() {
            const planHash = _.keyBy(this.plans, '_id');
            return this.currentPlans
                .filter(cp => this.paidSubscriptions.includes(cp.planId))
                .map(cp => ({
                    currentPlan: cp,
                    plan: planHash[cp.planId],
                }));
        },
    },
    data() {
        return {
            periods: {
                monthly: this.$t('billing.monthly'),
                'monthly-3': this.$t('billing.threeMonthly'),
                'monthly-6': this.$t('billing.sixMonthly'),
                annual: this.$t('billing.yearly'),
                'annual-2': this.$t('billing.twoYearly'),
                forever: this.$t('billing.forever'),
            },
            icons: {
                whatsapp: "CWhatsapp",
                "whatsapp-business": "WhatsappBusinessNew",
                supsis: "CSupsis",
                chatbot: "ChatbotNew",
                instagram: "CInstagram",
                telegram: "TelegramEntegration",
                custom: "CSupsis",
                appsumo: "AppSumo",
                messenger: "Messenger",
                trendyol: "trendyol",
                "meta-lead": "MetaIcon",
                "customer-tables": "CustomerTables",
                form: "Form",
                automation: "Automation",
                mail: "Mail",
                tasks: "Tasks",
                "webhook": "WebhookIntegration",
                "linkedin": "LinkedinEntegration",
                "voice-agent": "CAiVoice",
                "webphone": "WebphoneIcon",
            },
            showUserModal: false,
            reductionUsers: [],
            showCancelResourcesModal: false,
            cancelItem: null,
        };
    },
    methods: {
        onCancel() {
            this.$emit('cancel');
        },
        getIconName(type) {
            return this.icons[type] || 'CSupsis';
        },
        getTitle(type) {
            const title = type
                .split('-')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
            const i18nKey = `message.plans.types.${type.replace('-', '_')}`;
            return this.$t(i18nKey) === i18nKey ? title : this.$t(i18nKey);
        },
        getQuantity(item) {
            const type = item.plan.type;
            const data = { freeCount: 0, paidCount: 0 };
            if (type === 'supsis') {
                data.freeCount = this.features.freeAgentCount;
                data.paidCount = this.features.maxAgentCount - this.features.freeAgentCount;
            } else if (type === 'chatbot') {
                data.paidCount = this.features.totalSessionCount;
            } else if (type === 'whatsapp') {
                data.paidCount = this.features.maxWhatsappChannel;
            } else if (type === 'whatsapp-business') {
                data.paidCount = this.features.maxBusinessWhatsappChannel;
            } else if (type === 'instagram') {
                data.paidCount = this.features.maxInstagramChannel;
            } else if (type === 'messenger') {
                data.paidCount = this.features.maxMessengerChannel;
            } else if (type === 'meta-lead') {
                data.paidCount = this.features.maxMetaLeadChannel;
            } else if (type === 'automation') {
                data.paidCount = this.features.maxAutomationTask;
            } else if (type === 'trendyol') {
                data.paidCount = this.features.maxTrendyolChannel;
            } else if (type === 'mail') {
                data.paidCount = this.features.maxMailCount;
            } else if (type === 'linkedin') {
                data.paidCount = this.features.maxLinkedinChannel;
            } else if (type === 'telegram') {
                data.paidCount = this.features.maxTelegramChannel;
            } else if (type === 'webphone') {
                data.paidCount = this.features.maxWebphoneChannel;
            }
            return {
                total: data.freeCount + data.paidCount,
                free: data.freeCount,
                paid: data.paidCount,
            };
        },
        getQuantityText(type) {
            if (type === 'supsis') return this.$t('chatWindow.agent');
            if (type === 'chatbot') return this.$t('report.session');
            if (type === 'automation') return this.$t('task.task');
            if (type === 'mail') return this.$t('visitor.mail');
            if ([
                'whatsapp',
                'whatsapp-business',
                'instagram',
                'messenger',
                'meta-lead',
                'trendyol',
                'linkedin',
                'telegram',
                'voice-agent',
                'webphone',
            ].includes(type)) {
                return this.$t('message.channel');
            }
            return this.$t('message.perPageInFilter');
        },
        tryCancel(item) {
            const can = this.canUnsubscribe(item);
            if (can) {
                this.$dialog
                    .confirm("Bu aboneliği iptal etmek istediğinize emin misiniz?", {
                        okText: "Evet",
                        cancelText: "Hayır",
                        customClass: 'supsis-dialog',
                    })
                    .then(() => {
                        this.$emit('unsubscribe', {
                            planId: item.plan._id,
                            planType: item.plan.dynamicType || item.plan.type,
                        });
                    });
                return;
            }
            this.cancelItem = item;
            this.showCancelResourcesModal = true;
        },
        canUnsubscribe({ plan }) {
            const channelsCount = this.channels.reduce((acc, channel) => {
                acc[channel.type] = (acc[channel.type] || 0) + 1;
                return acc;
            }, {});

            if (plan.type === 'supsis') {
                return (this.activeUserCount || 0) === 1;
            } else if (plan.type === 'whatsapp-business') {
                return (channelsCount['whatsapp-business-api'] || 0) + (channelsCount['whatsapp-business-api-supsis'] || 0) <= 0;
            } else if (plan.type === 'whatsapp') {
                return ((channelsCount['whatsapp-qr'] || 0) + (channelsCount['whatsapp-v2'] || 0) + (channelsCount['whatsapp-unipile'] || 0)) <= 0;
            } else if (plan.type === 'instagram') {
                return (channelsCount['instagram'] || 0) <= 0;
            } else if (plan.type === 'messenger') {
                return (channelsCount['messenger'] || 0) <= 0;
            } else if (plan.type === 'meta-lead') {
                return (channelsCount['meta-leads'] || 0) <= 0;
            } else if (plan.type === 'trendyol') {
                return (channelsCount['trendyol'] || 0) <= 0;
            } else if (plan.type === 'linkedin') {
                return (channelsCount['linkedin-unipile'] || 0) <= 0;
            } else if (plan.type === 'telegram') {
                return ((channelsCount['telegram-unipile'] || 0) + (this.telegramBotFatherEnabled ? 1 : 0)) <= 0;
            } else if (plan.type === 'voice-agent') {
                return (channelsCount['retell'] || 0) <= 0;
            } else if (plan.type === 'webphone') {
                const kirmiziSantralChannels = channelsCount['webphone-kirmizisantral'] || 0;
                const telnyxChannels = channelsCount['webphone-telnyx'] || 0;
                return (kirmiziSantralChannels + telnyxChannels) <= 0;
            }
            return true;
        },
    },
};
</script>

<style scoped>
.subscription-management-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.plans-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.plans-title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #222;
}

.plans-list-new {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.plan-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #ffffff;
    border: 1px solid #eaeaea;
    border-radius: 10px;
    padding: 16px 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

.plan-card .left {
    display: flex;
    gap: 14px;
    align-items: center;
}

.icon-wrapper {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.labels .title {
    font-weight: 600;
    font-size: 15px;
    color: #222;
}

.chips {
    display: flex;
    gap: 6px;
    margin-top: 4px;
}

.chip {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 2px 8px;
    font-size: 11px;
    color: #666;
}

.actions {
    display: flex;
    align-items: center;
}
</style>
